import { isEmptyArray } from '~/common'

export function sleep(timeout: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout)
  })
}

/**
 * Executes a promise if the condition is true, otherwise returns undefined.
 * @param condition the condition to check
 * @param promise the promise to execute if the condition is true
 */
export const maybe = async <T = any>(condition: boolean, promise: () => Promise<T>): Promise<T | undefined> =>
  condition ? promise() : Promise.resolve(undefined)

//@note isBoolean of lodash still will not allow for 'true', 'false' - having said, it is a good idea to adhere a different type for that situation, tbh
export const isBoolean = (value: unknown) => value instanceof Boolean || ['true', 'false'].includes(`${value}`)

export const isItEmpty = (value) => {
  if (isEmptyArray(value)) {
    return true
  }

  if (Number.isSafeInteger(value)) {
    return false
  }

  if (isBoolean(value)) {
    return false
  }

  return !value
}

/**
 * Returns the value of a fulfilled promise result, or undefined if the promise was rejected.
 */
export const getSettledValue = <T>(result: PromiseSettledResult<T>): T | undefined =>
  result.status === 'fulfilled' ? result.value : undefined
